import React, {Component, ReactElement, ReactNode} from 'react'
import {NatGetResidentUserAuthed, SubResidentUserInfo} from '../residentUser/repository/NatGetResidentUserAuthed';
import NatResidentUserRepo from '../residentUser/repository/NatResidentUserRepo'
import {MAIL_ADDRESS_TYPE, MAIL_MAGAZINE_RECEIVING_DO_OR_NOT, NOTIFICATION_DO_OR_NOT,} from '../../../CodeMaster'
import {Messages} from '../../../Messages'
import {
    ContentsMainTitle,
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    IconFont,
    MainContainer,
} from '../../../styledComponents/ContentsArea'
import {
    StyledDiv,
    StyledI,
    StyledSpan,
    StyledTable,
    StyledTd,
    StyledTr,
} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {BreakPoint, Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {PrimaryStyledButton} from '../../../styledComponents/Button'
import {generateMedia} from 'styled-media-query'
import {Box} from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'
import MailIcon from '@mui/icons-material/Mail'
import {StylesProvider} from '@mui/styles'
import {Nullable} from '../../../app/TypeHelpers'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {convertToRoomNumberForResident, judgeAuthorityCheck, NatAsyncCallFunction} from '../../common/util/Natutil'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {Location} from 'react-router-dom'
import {
    MainUser,
    NatGetResidentUserInvolvingSub,
    SubUser
} from '../residentUser/repository/NatGetResidentUserInvolvingSub'
import ResidentGeneralMeetingRepo, {
    GetUnitOwnerByLoginUserRoomResponse,
    UnitOwner
} from '../../../components/generalMeeting/ResidentGeneralMeetingRepo'

const LOGIN_USER_RESIDENT_USER_TYPE: string = 'loginUserResidentUserType';
const SELECTED_ROOM_NUMBER: string = 'selectedRoomNumber';
const SELECTED_RIDGE_NAME: string = 'selectedRidgeName';
const SELECTED_CONDOMINIUM_CD: string = 'selectedCondominiumCd';
const SELECTED_RIDGE_CD: string = 'selectedRidgeCd';

interface Props {
    residentUserRepo: NatResidentUserRepo,
    residentGeneralMeetingRepo: ResidentGeneralMeetingRepo,
    location: Location,
}

interface States {
    subResidentUserInfo: SubResidentUserInfo[]
    ridgeName: string | null
    roomNumber: string | null
    condominiumCd: string | null
    ridgeCd: string | null
    parentResidentId: string
    familyName: string
    firstName: string
    familyNameKana: string
    firstNameKana: string
    mailAddressPc: string
    mailAddressMb: string
    sutekiNetOfNotice: string
    isLoadCompleted: boolean
    bulletinBoardCommentNotice: string
    billingAmountFixNotice: string
    mainUser: MainUser
    subUser: SubUser[]
    unitOwner: Nullable<UnitOwner>
}

class NatResidentPersonalSettingPage extends Component<Props & ResidentPagePropsSet, States> {

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)

        const ridgeName: string | null = window.sessionStorage.getItem(SELECTED_RIDGE_NAME);
        const roomNumber: string | null = window.sessionStorage.getItem(SELECTED_ROOM_NUMBER);
        const condominiumCd: string | null = window.sessionStorage.getItem(SELECTED_CONDOMINIUM_CD);
        const ridgeCd: string | null = window.sessionStorage.getItem(SELECTED_RIDGE_CD);

        this.state = {
            subResidentUserInfo: [],
            ridgeName: ridgeName,
            roomNumber: roomNumber,
            condominiumCd: condominiumCd,
            ridgeCd: ridgeCd,
            parentResidentId: '',
            familyName: '',
            firstName: '',
            familyNameKana: '',
            firstNameKana: '',
            mailAddressPc: '',
            mailAddressMb: '',
            sutekiNetOfNotice: '',
            bulletinBoardCommentNotice: '',
            billingAmountFixNotice: '',
            isLoadCompleted: false,
            mainUser: {
                seq: 0,
                userId: '',
                familyName: '',
                firstName: '',
                mailAddressPc: null,
                mailAddressMb: null,
            },
            subUser: [],
            unitOwner: null,
        };

        this.changeUserNameButtonClick = this.changeUserNameButtonClick.bind(this)
        this.passwordResetButtonClick = this.passwordResetButtonClick.bind(this)
        this.subResidentUserButtonClick = this.subResidentUserButtonClick.bind(this)
        this.mailNoticeSettingButtonClick = this.mailNoticeSettingButtonClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // ユーザ情報取得
            const retResidentUser: Nullable<NatGetResidentUserAuthed> = await NatAsyncCallFunction(
                this.props.residentUserRepo.getResidentUserLogined.bind(
                    this.props.residentUserRepo), this.props.navigate)

            if (retResidentUser && retResidentUser.details !== null) {
                this.setState({
                    subResidentUserInfo: retResidentUser.details.subResidentUserInfo,
                    familyName: retResidentUser.details.familyName,
                    firstName: retResidentUser.details.firstName,
                    familyNameKana: retResidentUser.details.familyNameKana,
                    firstNameKana: retResidentUser.details.firstNameKana,
                    mailAddressPc: retResidentUser.details.mailAddressPc,
                    mailAddressMb: retResidentUser.details.mailAddressMb,
                    sutekiNetOfNotice: '',
                    bulletinBoardCommentNotice: '',
                    billingAmountFixNotice: '',
                });

                const sutekiNetOfNotice: any
                    = MAIL_MAGAZINE_RECEIVING_DO_OR_NOT.codeToEnumConstants(retResidentUser.details.sutekiNetOfNotice)
                if (sutekiNetOfNotice !== undefined) {
                    this.setState({sutekiNetOfNotice: sutekiNetOfNotice.label})
                }

                const bulletinBoardCommentNotice: any
                    = NOTIFICATION_DO_OR_NOT.codeToEnumConstants(retResidentUser.details.bulletinBoardCommentNotice)
                if (bulletinBoardCommentNotice !== undefined) {
                    this.setState({bulletinBoardCommentNotice: bulletinBoardCommentNotice.label})
                }

                const billingAmountFixNotice: any
                    = NOTIFICATION_DO_OR_NOT.codeToEnumConstants(retResidentUser.details.billingAmountFixNotice);
                if (billingAmountFixNotice !== undefined) {
                    this.setState({billingAmountFixNotice: billingAmountFixNotice.label})
                }

                if (this.state.condominiumCd && this.state.ridgeCd && this.state.roomNumber) {
                    const retResidentUserInfo: Nullable<NatGetResidentUserInvolvingSub> =
                        await NatAsyncCallFunction(
                            this.props.residentUserRepo.getResidentUserInvolvingSub.bind(
                                this.props.residentUserRepo, this.state.condominiumCd,
                                this.state.ridgeCd, this.state.roomNumber), this.props.navigate);

                    if (retResidentUserInfo?.details) {
                        this.setState({
                            mainUser: retResidentUserInfo.details.mainUser,
                            subUser: retResidentUserInfo.details.subUser
                        })
                    }
                }
            }

            if (!retResidentUser) {
                return
            }
            if (judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_UNIT_OWNER_CONFIRMATION)) {
                const unitOwnerResponse: Nullable<GetUnitOwnerByLoginUserRoomResponse> = await NatAsyncCallFunction(
                    this.props.residentGeneralMeetingRepo.getUnitOwnerByLoginUserRoom.bind(
                        this.props.residentGeneralMeetingRepo,
                    ), this.props.navigate)
                if (unitOwnerResponse) {
                    this.setState({
                        unitOwner: unitOwnerResponse.details
                    })
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    // プロフィール情報を変更する
    changeUserNameButtonClick(): void {
        this.props.navigate(
            `/resident/changeUserName`,
        )
    }

    // メールアドレスを変更する
    changeMailAddressButtonClick(mailAddressType: string): void {
        this.props.navigate(
            `/resident/changeMailAddress`,
            {state: {mailAddressType: mailAddressType}},
        )
    }

    // パスワードを変更する
    passwordResetButtonClick(): void {
        this.props.navigate(
            `/resident/changePasswordInput`,
        )
    }

    // ユーザを管理する
    subResidentUserButtonClick(): void {
        this.props.navigate(
            `/resident/condominiums/${this.state.condominiumCd}/ridges` +
            `/${this.state.ridgeCd}/rooms/${this.state.roomNumber}/users`,
        )
    }

    // メール通知設定を変更する
    mailNoticeSettingButtonClick(): void {
        this.props.navigate(
            `/resident/mailNoticeSetting`,
        )
    }

    renderResidentUserInfo(familyName: string, firstName: string): ReactNode {
        return <div>{familyName} {firstName}</div>
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <StylesProvider injectFirst>
                <BasePersonalWarraper>

                    <BaseBasePersonalMainTitleArea>
                        <BasePersonalMainTitle><TitleIcon/>
                            <BasePersonalTitleBorder>
                                個人設定
                            </BasePersonalTitleBorder>
                        </BasePersonalMainTitle>
                    </BaseBasePersonalMainTitleArea>
                    <BasePersonalDescriptionWrapper>
                        <BasePersonalDescriptionInnerTxt>
                            ご登録いただいている情報の確認・変更ができます。
                        </BasePersonalDescriptionInnerTxt>
                        <BasePersonalDescriptionInnerTxt>
                            変更する場合は各項目の[変更する]ボタンから編集画面へ進んでください。
                        </BasePersonalDescriptionInnerTxt>
                    </BasePersonalDescriptionWrapper>

                    <BasePersonalSubTitleWrapper>
                        <BasePersonalSubTitleInnerTxt>
                            プロフィール情報
                        </BasePersonalSubTitleInnerTxt>
                    </BasePersonalSubTitleWrapper>
                    <MainContainer>
                        <BasePersonalTable>
                            <BasePersonaTr>
                                <BasePersonalTdTitle>部屋番号</BasePersonalTdTitle>
                                <BasePersonalTd>
                                    {this.state.ridgeName} {convertToRoomNumberForResident(this.state.roomNumber)}
                                </BasePersonalTd>
                            </BasePersonaTr>
                            <BasePersonaTr>
                                <BasePersonalTdTitle>氏名</BasePersonalTdTitle>
                                <BasePersonalTd>{this.state.familyName} {this.state.firstName}</BasePersonalTd>
                            </BasePersonaTr>
                            <BasePersonaTr>
                                <BasePersonalTdTitle>フリガナ</BasePersonalTdTitle>
                                <BasePersonalTd>{this.state.familyNameKana} {this.state.firstNameKana}</BasePersonalTd>
                            </BasePersonaTr>
                        </BasePersonalTable>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_RESIDENT_USER}>
                            <Box pt={'15px'} pb={'15px'}>
                                <PrimaryStyledButton
                                    onClick={this.changeUserNameButtonClick}>
                                    プロフィール情報を変更する
                                </PrimaryStyledButton>
                            </Box>
                        </AuthorityChecker>
                    </MainContainer>

                    <SubTitleBorder/>

                    <BasePersonalSubTitleWrapper>
                        <BasePersonalSubTitleInnerTxt>
                            メールアドレス
                        </BasePersonalSubTitleInnerTxt>
                    </BasePersonalSubTitleWrapper>
                    {(this.state.mailAddressPc) ?
                        <MainContainer>
                            <BasePersonalTable>
                                <BasePersonaTr>
                                    <SpHiddenPersonalTdTitle>メールアドレス</SpHiddenPersonalTdTitle>
                                    <BasePersonalTd>{this.state.mailAddressPc}</BasePersonalTd>
                                </BasePersonaTr>
                            </BasePersonalTable>
                            <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_RESIDENT_USER}>
                                <Box pt={'15px'} pb={'15px'}>
                                    <PrimaryStyledButton
                                        onClick={() => this.changeMailAddressButtonClick(MAIL_ADDRESS_TYPE.PC.value)}>
                                        メールアドレスを変更する
                                    </PrimaryStyledButton>
                                </Box>
                            </AuthorityChecker>
                        </MainContainer>
                        :
                        <MainContainer>
                            <SecureTxt>{Messages.IOPCC0015.toString('メールアドレス')}</SecureTxt>
                            <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_RESIDENT_USER}>
                                <Box pt={'15px'} pb={'15px'}>
                                    <PrimaryStyledButton
                                        onClick={() => this.changeMailAddressButtonClick(MAIL_ADDRESS_TYPE.PC.value)}>
                                        メールアドレスを登録する
                                    </PrimaryStyledButton>
                                </Box>
                            </AuthorityChecker>
                        </MainContainer>
                    }
                    <SubTitleBorder/>

                    <BasePersonalSubTitleWrapper>
                        <BasePersonalSubTitleInnerTxt>
                            パスワード
                        </BasePersonalSubTitleInnerTxt>
                    </BasePersonalSubTitleWrapper>
                    <MainContainer>
                        <SecureTxt>セキュリティ上の理由により、表示いたしません。</SecureTxt>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_RESIDENT_USER}>
                            <Box pt={'15px'} pb={'15px'}>
                                <PrimaryStyledButton
                                    onClick={this.passwordResetButtonClick}>
                                    パスワードを変更する
                                </PrimaryStyledButton>
                            </Box>
                        </AuthorityChecker>
                    </MainContainer>

                    <SubTitleBorder/>
                    <BasePersonalSubTitleWrapper>
                        <BasePersonalSubTitleInnerTxt>ユーザ一覧</BasePersonalSubTitleInnerTxt>
                    </BasePersonalSubTitleWrapper>
                    <MainContainer>
                        <BasePersonalTable>
                            <BasePersonaTr>
                                <CustomPersonalTdTitle>ユーザ</CustomPersonalTdTitle>
                                <CustomPersonalTd>
                                    <UserList>
                                        {this.renderResidentUserInfo(
                                            this.state.mainUser.familyName, this.state.mainUser.firstName)}
                                        {this.state.subUser?.map(subResidentUser =>
                                            this.renderResidentUserInfo(
                                                subResidentUser.familyName, subResidentUser.firstName)
                                        )}
                                    </UserList>
                                </CustomPersonalTd>
                            </BasePersonaTr>
                            <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_UNIT_OWNER_CONFIRMATION}>
                                <Box height={'15px'}/>
                                <BasePersonaTr>
                                    <CustomPersonalTdTitle>区分所有者</CustomPersonalTdTitle>
                                    <CustomPersonalTd>{this.state.unitOwner
                                        ? this.state.unitOwner.name || '表示できません'
                                        : '確認されていません'
                                    }</CustomPersonalTd>
                                </BasePersonaTr>
                            </AuthorityChecker>
                        </BasePersonalTable>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_RESIDENT_USER}>
                            <Box pt={'15px'} pb={'15px'}>
                                <PrimaryStyledButton
                                    onClick={this.subResidentUserButtonClick}>
                                    ユーザを管理する
                                </PrimaryStyledButton>
                            </Box>
                        </AuthorityChecker>
                    </MainContainer>

                    <SubTitleBorder/>

                    <BasePersonalSubTitleWrapper>
                        <BasePersonalSubTitleInnerTxt>
                            メール受信設定
                        </BasePersonalSubTitleInnerTxt>
                    </BasePersonalSubTitleWrapper>
                    <MainContainer>
                        <BasePersonalTable>
                            <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.VIEW_BILLING_AMOUNT}>
                                <BasePersonaTr>
                                    <BasePersonalTdTitle>ご請求金額の確定通知</BasePersonalTdTitle>
                                    <BasePersonalTd>{this.state.billingAmountFixNotice}</BasePersonalTd>
                                </BasePersonaTr>
                            </AuthorityChecker>
                            <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_BOARD_MANAGEMENT}>
                                <BasePersonaTr>
                                    <BasePersonalTdTitle>情報交換掲示板のコメント通知</BasePersonalTdTitle>
                                    <BasePersonalTd>{this.state.bulletinBoardCommentNotice}</BasePersonalTd>
                                </BasePersonaTr>
                            </AuthorityChecker>
                            <BasePersonaTr>
                                <BasePersonalTdTitle>すてきテラスのメールマガジン</BasePersonalTdTitle>
                                <BasePersonalTd>{this.state.sutekiNetOfNotice}</BasePersonalTd>
                            </BasePersonaTr>
                        </BasePersonalTable>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_RESIDENT_USER}>
                            <Box pt={'15px'} pb={'15px'}>
                                <PrimaryStyledButton
                                    onClick={this.mailNoticeSettingButtonClick}>
                                    メール受信設定を変更する
                                </PrimaryStyledButton>
                            </Box>
                        </AuthorityChecker>
                    </MainContainer>
                </BasePersonalWarraper>
            </StylesProvider>
        )
    }
}

export default createResidentPage(NatResidentPersonalSettingPage)

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

export const BasePersonalWarraper: StyledDiv = styled.div`
  ${breakPoint.lessThan('sp')`
    background-color: ${Colors.Surface};
  `}
`

export const BaseBasePersonalMainTitleArea: StyledDiv = styled.div`
  display: block;

  ${breakPoint.lessThan('sp')`
    padding: 15px;
    background-color: ${Colors.Surface};
  `}
`

export const BasePersonalMainTitle = styled(ContentsMainTitle)`
  ${breakPoint.lessThan('sp')`
    font-size: ${FontSize.Body};
    font-weight: initial;
    margin-top: initial;
    margin-bottom: initial;
    padding: initial;
    text-align: initial;
  `}
`

export const BasePersonalDescriptionWrapper: StyledDiv = styled.div`
  margin: 0 100px 0 100px;
  background-color: ${Colors.Surface};

  ${breakPoint.lessThan('sp')`
     margin: initial;
     padding: 0px 30px 30px 30px;
  `}
`

export const BasePersonalDescriptionInnerTxt: StyledSpan = styled.span`
  display: inline-block;
`

export const BasePersonalSubTitleWrapper = styled(ContentsSubTitleWrapper)`
  ${breakPoint.lessThan('sp')`
    font-size: ${FontSize.Body};
    font-weight: ${FontWeights.Normal};
    text-align: left;
    padding: 0;
    margin: 0;
    &::before {
      content: initial;
    }
  `}
`

export const BasePersonalSubTitleInnerTxt = styled(ContentsSubTitleInner)`
  ${breakPoint.lessThan('sp')`
    background-color: ${Colors.Surface};
  `}
`

const TitleIcon: StyledI = styled.i`
  ${IconFont};
  font-size: 6.0rem;
  padding-right: 15px;

  &::before {
    content: "\f139";
  }

  ${breakPoint.lessThan('sp')`
    display: none;
  `}
`

export const BasePersonalTable: StyledTable = styled.table`
  border: none;
  width: 100%;
  ${breakPoint.lessThan('sp')`
    display: block;
  `}
`

export const BasePersonaTr: StyledTr = styled.tr`
  border: none;
  ${breakPoint.lessThan('sp')`
    display: block;
  `}
`

export const BasePersonalTdTitle: StyledTd = styled.td`
  border: none;
  padding-right: 15px;
  padding-left: 150px;
  width: 45%;
  vertical-align: top;
  ${breakPoint.lessThan('sp')`
    display: block;
    background-color: ${Colors.Background};
    padding-left: 15px;
    border-top: 1.5px solid ${Colors.AccentLight};
    border-bottom: 1.5px solid ${Colors.AccentLight};
    width: initial;
  `}
`

const SpHiddenPersonalTdTitle = styled(BasePersonalTdTitle)`
  ${breakPoint.lessThan('sp')`
    display: none;
  `}
`

export const BasePersonalTd: StyledTd = styled.td`
  border: none;
  word-break: break-all;
  ${breakPoint.lessThan('sp')`
    display: block;
    padding-left: 15px;
  `}
`

const BasePersonalUserTable = styled(BasePersonalTable)`
    text-align: center;
`;

const CustomPersonalTdTitle = styled(BasePersonalTdTitle)`
  ${breakPoint.lessThan('sp')`
        display: initial;
        background-color: initial;
        padding-left: 0;
        border-top: initial;
        border-bottom: initial;
        width: initial;
  `}
`

const CustomPersonalTd = styled(BasePersonalTd)`
  ${breakPoint.lessThan('sp')`
        padding: 10px 0 0 15px;
    `}
`

const UserList = styled.div`
  ${breakPoint.lessThan('sp')`
        display: flex;
        flex-direction: column;
        gap: 5px;
  `}
`

export const BasePersonalSubUserTr = styled(BasePersonaTr)`
  text-align: left;
  ${breakPoint.lessThan('sp')`
    display: table;
  `}
`

export const BasePersonalSubUserTdTitle = styled(BasePersonalTdTitle)`
  width: 20%;

  ${breakPoint.lessThan('sp')`
    display: table;
    background-color: initial;
    padding-left: 15px;
    border-top: initial;
    border-bottom: initial;
    width: initial;
  `}
`

export const BasePersonalSubUserTd = styled(BasePersonalTd)`
  ${breakPoint.lessThan('sp')`
        display: flex;
        flex-direction: column;
        gap: 5px;
  `}
`


export const BasePersonalTitleBorder: StyledDiv = styled.div`
  display: inline-block;

  ${breakPoint.lessThan('sp')`
    padding-left: 8px;
    border-left: 8px solid ${Colors.Primary};
  `}
`

const SubTitleBorder: StyledDiv = styled.div`
  display: none;

  ${breakPoint.lessThan('sp')`
    display: block;
    margin: 5px 15px 15px 15px;
    border-top: 1.5px solid ${Colors.AccentDark};
  `}
`

export const BasePersonalIcon = styled(PersonIcon)`
  font-size: 1.25rem;

  &.MuiSvgIcon-root {
    ${breakPoint.lessThan('sp')`
     font-size: 2.1875rem;
  `}
  }
`

export const BasePersonalMailIcon = styled(MailIcon)`
  font-size: 1.25rem;

  &.MuiSvgIcon-root {
    ${breakPoint.lessThan('sp')`
      font-size: 2.1875rem;
  `}
  }
`

const SecureTxt: StyledDiv = styled.div`
  text-align: center;
  color: ${Colors.AccentLight};
`

